import React from "react";
import { Box } from "@tiny/components";
import { SearchPanelProps } from "./SearchPanel.types";
import { useSearchPanel } from "./SearchPanel.hooks";
import { SearchPanelProvider } from "./SearchPanel.context";
import SearchPanelHeader from "./SearchPanelHeader/SearchPanelHeader";
import SearchPanelContent from "./SearchPanelContent/SearchPanelContent";
import SearchPanelFooter from "./SearchPanelFooter/SearchPanelFooter";

function SearchPanel<T>(props: SearchPanelProps<T>) {
  const { boxProps, ...listPanelView } = useSearchPanel(props);

  const { MoreDialogComponent, moreOpen, closeMore } = listPanelView;

  return (
    <SearchPanelProvider value={listPanelView}>
      <Box {...boxProps}>
        <SearchPanelHeader />
        <SearchPanelContent />
        {props.disablePagination ? <></> : <SearchPanelFooter />}
      </Box>
      {MoreDialogComponent && (
        <MoreDialogComponent open={moreOpen} onClose={closeMore} />
      )}
    </SearchPanelProvider>
  );
}

export default SearchPanel;
